import { getToken, getUser } from "../../../Helpers/Utils/Common";
import { getAPICallWithParams, postAPICall } from "../../axiosMethodCalls";
import { getQrWithParamsAPICall, postQrAPICall } from "../../../Components/Helpers/API/axiosMethodCall";

export const fetchDashboard = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/index",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchDailySales = async (info) => {
  try {
    const currentDate = new Date();
    const dateToday = currentDate.toISOString().split("T")[0];
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      date_from: dateToday,
      date_to: dateToday,
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/total_sales",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchTotalSales = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/total_sales",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchFollowUpsForTomorrow = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      tomorrow: info[0],
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/no_of_upcoming_checkups",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchNewPatients = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      date_from: info[0],
      date_to: info[1],
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/no_of_new_patients",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchUpcomingCheckups = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/no_of_upcoming_checkups",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchQueuedPatients = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/no_of_queued_patients",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchFreeCheckups = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      pf_method: info[0],
      date_from: info[1],
      date_to: info[2],
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/no_of_checkups",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchTotalCheckupsToday = async (info) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      date_from: info[0],
      date_to: info[1],
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "dashboard/no_of_checkups",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchCensusOfDiseases = async (info) => {
  try {
    const currentDate = new Date();
    const dateToday = currentDate.toISOString().split("T")[0];
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      date_from: dateToday,
      date_to: dateToday,
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "graphs/census_of_diseases_percentage",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchPeakHours = async (info) => {
  try {
    const currentDate = new Date();
    const dateToday = currentDate.toISOString().split("T")[0];
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      date_from: dateToday,
      date_to: dateToday,
    };
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "graphs/peak_hours",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

// ChrPatient / Queue API endpoints (uses REACT_APP_LINK_CSR with QR API key)

export const searchTransaction = async (transactionNo) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      transaction_no: transactionNo,
      origin: "emr",
    };
    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_CSR + "bookings/search_transaction",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchPriorityList = async (page = 1) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      page: page,
      origin: "emr",
    };
    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/priority",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const removePriority = async (queueId) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      queue_id: queueId,
      origin: "emr",
    };
    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/remove_priority",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const fetchQueueList = async (priorityType) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      priority_type: priorityType,
      origin: "emr",
    };
    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const setNowServing = async (queueId, prevQueueId, lane) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      queue_id: queueId || '',
      prev_queue_id: prevQueueId || '',
      lane: lane || 'yakap',
      origin: "emr",
    };
    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/now_serving",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const skipQueue = async (queueId) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      queue_id: queueId || '',
      origin: "emr",
    };
    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/csr_skip",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const searchPatient = async (firstName, lastName, middleName, birthdate) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      first_name: firstName,
      last_name: lastName,
      middle_name: middleName,
      birthdate: birthdate,
      origin: "emr",
    };
    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_CSR + "patients/search",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const queueToCSR = async (queueId, patientId = null, queueNo = null, assessmentType = null, patientMasterId = null) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      queue_id: queueId || '',
      is_post_consultation: 0,
      assessment_type: "ekonsulta",
      origin: "emr",
      priority_type: "emr",
    };
    
    // Add optional parameters if provided
    if (patientId) payload.patient_id = patientId;
    if (queueNo) payload.queue_no = queueNo;
    if (patientMasterId) payload.patient_master_id = patientMasterId;
    
    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/generate",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const markQueueDone = async (queueId) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      queue_id: queueId || '',
      origin: "emr",
    };
    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "patient_queues/done",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};





